module.exports = __webpack_public_path__ + "img/laboratory_04.35c62ce0.png";